const SmsConfigurationKeys = {
  TITLE: "title",
  ID: "id",
  CONTENT: "content",
  START_DATE: "startDate",
  END_DATE: "endDate",
  PRIORITY: "priority",
  ACTIVE: "active",
  CREATED_BY: "createdBy",
  CREATED_DATE: "createdDate",
  UPDATED_BY: "updatedBy",
  UPDATED_DATE: "updatedDate",
  VERSION: "version",
  ADD_WHITE_LABEL_GROUP: "addWhiteLabelGroup",
  EDIT_WHITE_LABEL_GROUP: "editWhiteLabelGroup",
  ADD_NEW_WHITE_LABEL_GROUP: "addNewWhiteLabelGroup",
  CREATE_BUTTON: "createButton",
  EDIT_BUTTON: "editButton",
  DELETE_BUTTON: "deleteButton",
  DELETE_CONTENT: "deleteContent",
  CANCEL_DELETE_BUTTON: "cancelDeleteButton",
  CONFIRM_DELETE_BUTTON: "confirmDeleteButton",
  ACTIVE_OPTION: "activeOption",
  INACTIVE_OPTION: "inactiveOption",
  SmsConfigurationWhiteLabelGroup: {
    TITLE: "smsConfigurationWhiteLabelGroup.title",
    HEADER_ID: "smsConfigurationWhiteLabelGroup.headerId",
    WHITE_LABEL_GROUP: "smsConfigurationWhiteLabelGroup.whiteLabelGroup"
  },
  Validations: {
    ERROR_MSG_ALPHA_NUMERIC: "validations.errMsgAlphaNumeric",
    ERROR_MSG_NUMERIC: "validations.errMsgNumeric",
    ERROR_MSG_MAX_LENGTH: "validations.errMsgMaxLength"
  }
}

export default SmsConfigurationKeys
